import { IPackageContent } from '../models/billing.model';

export const packageContent: IPackageContent[] = [
  {
    icon: 'https://storage.googleapis.com/komerce/rajaongkir/starter-ro-icon.svg',
    use: 'For simple websites',
    name: 'Starter',
    desc: 'Display real-time shipping costs in your online store. Perfect for businesses with manual shipping processes.',
    normalPrice: 'Rp 50.000',
    saving: '100%',
    price: 'Free',
    vat: false,
    feature: [
      'Real-Time Shipping Cost Check API',
      'API Payment Service',
      'API QRISLY',
      '100 Request API/Day (API Shipping Cost Check)',
      'Check shipping costs for 17 domestic couriers (JNE, JNT, SiCepat, etc.)',
      'Check shipping costs for 6 international couriers',
    ],
    nor: ['API Shipping Delivery'],
    action: 'Activate',
  },
  {
    icon: 'https://storage.googleapis.com/komerce/rajaongkir/pro-ro-icon.svg',
    use: 'For Complex Website',
    name: 'Pro',
    desc: 'Check shipping costs for more transactions with a more comprehensive shipping service. Perfect for stores with a growing number of orders.',
    normalPrice: 'Rp 200.000',
    saving: '25%',
    price: '149.000,-',
    vat: true,
    feature: [
      'All Starter features',
      '25.000 Request API/Day (API Shipping Cost Check)',
      'Faster response time',
    ],
    nor: ['API Shipping Delivery'],
    action: 'Upgrade',
  },
  {
    icon: 'https://storage.googleapis.com/komerce/rajaongkir/enterprise-ro-icon.svg',
    use: 'For E-Commerce',
    name: 'Enterprise',
    desc: 'Full automation from shipping cost checking, receipt creation, pickup, to payment acceptance. Full integration for efficient operations.',
    normalPrice: 'Rp 400.000',
    saving: '38%',
    price: '249.000,-',
    vat: true,
    feature: [
      'All Pro features',
      '50.000 Request API/Day (API Cek Ongkir)',
      'API Shipping Delivery (Create AWB, Pickup, Tracking, Print label)',
      'API Payment Service (VA, E-wallet, QRIS, Automatic Notification)',
      'API QRISLY (Generate Static QRIS to Dynamic)',
      '1 Month Free Integration Period (For new subscribers)',
      'Priority Support (Whatsapp Group)',
    ],
    action: 'Upgrade',
  },
];

export const starterBenefits = [
  'Real-time Shipping Rate API',
  'Payment Service API',
  'QRISLY API',
  '100 API Hits/Day (Shipping Rate API)',
  'Check Shipping Costs for 17 Domestic Couriers',
  'Check Shipping Costs for 6 International Couriers',
];

export const proBenefits = [
  'Real-time Shipping Rate API',
  'Payment Service API',
  'QRISLY API',
  '25,000 API Requests/Day (Shipping Rate Check)',
  'Check Shipping Costs for 17 Domestic Couriers',
  'Check Shipping Costs for 6 International Couriers',
  'Faster Response Time'
];

export const enterpriseBenefits = [
  'Real-time Shipping Rate API',
  '50,000 API Requests/Day (Shipping Rate API)',
  'Check Shipping Costs for 17 Domestic Couriers',
  'Check Shipping Costs for 6 International Couriers',
  'Shipping & Delivery API (AWB Generation, Pickup, Tracking, Label Printing)',
  'Payment Service API (Virtual Accounts, E-wallets, QRIS, Automated Notifications)',
  'QRISLY API (Convert Static QRIS to Dynamic)',
];
